import axios from "axios";
import { formatDate } from "utils/date";
import { buildQuery } from "utils/queryUtils";

export const findProcessStatusForeigns = (headers, params) => {
    let query = buildQuery(params, []);
    if (params.filters.applicaitonId?.value) {
        query += `&applicaitonId=${params.filters.applicaitonId.value?.trim()}`;
    }
    if (params.filters.passportNo?.value) {
        query += `&passportNo=${params.filters.passportNo.value?.trim()}`;
    }
    if (params.filters.fullName?.value) {
        query += `&fullName=${params.filters.fullName.value?.trim().toLowerCase()}`;
    }
    if (params.filters.birthDay?.value) {
        query += `&birthDay=${formatDate(params.filters.birthDay.value)}`;
    }
    return axios.get(`${process.env.REACT_APP_REGISTER_OLN_API_URL}/processing-status-foreign${query}`, {
        headers,
    });
};

export const findImgProcessStatusForeign = (headers, id) => {
    return axios.get(`${process.env.REACT_APP_REGISTER_OLN_API_URL}/processing-status-foreign/${id}`, {
        headers,
    });
};
